import { AxiosPromise } from 'axios';
import { ServicioProxy } from '../../../config/enums';
import { AxiosVue } from '../../../AxiosVue';

type DashboardResponse<T = any> = {
  MENSAJE_RESPUESTA?: string;
  CODIGO_RESPUESTA?: string;
  LISTA?: T;
};

type RequestParams<T = any> = {
  serviceClient?: string;
  endpoint?: string;
  body?: { [key: string]: T };
};

const axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

const makeHttpRequest = ({
  serviceClient = 'ConectaAtenciones',
  endpoint = 'get_all',
  body = {},
}: RequestParams): AxiosPromise<DashboardResponse> =>
  axios.http.post<DashboardResponse>(
    `Metabase/PostgenericA/${serviceClient}/${endpoint}`,
    body
  );

export const fetchAtenciones = (
  params: RequestParams
): AxiosPromise<DashboardResponse> => makeHttpRequest(params);
